import { Mail } from 'lucide-react';
import { setHref, getHref } from '../../utils/browserNav';

const MobileEditorBanner = () => {
  const handleEmailLink = () => {
    const subject = encodeURIComponent('Gartenplan am Desktop bearbeiten');
    const body = encodeURIComponent(
      `Öffne diesen Link auf dem Desktop, um deinen Garten zu bearbeiten:\n${getHref()}`
    );
    setHref(`mailto:?subject=${subject}&body=${body}`);
  };

  return (
    <div
      className="absolute bottom-16 left-3 right-3 bg-white rounded-xl shadow-lg border border-gray-100 flex items-center gap-3 px-4 py-3"
      style={{ zIndex: 10 }}
      data-testid="mobile-editor-banner"
    >
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-medium text-gray-900 leading-tight">
          Bearbeitung am Desktop
        </p>
        <p className="text-[11px] text-gray-500 leading-snug mt-0.5">
          Umriss, Pflanzen setzen und Höhenzonen gehen am großen Bildschirm schneller.
        </p>
      </div>
      <button
        onClick={handleEmailLink}
        className="flex-none flex items-center gap-1.5 px-3 h-9 bg-emerald-500 text-white text-[12px] font-medium rounded-lg whitespace-nowrap"
        aria-label="Link per E-Mail senden"
      >
        <Mail size={14} />
        E-Mail mit Link
      </button>
    </div>
  );
};

export default MobileEditorBanner;
